<template>
  <div id="feces" style="width: 100%; height: 100%"></div>
</template>
<script>
import * as echarts from "echarts";
export default {
  components: {},
  data() {
    return {};
  },
  mounted() {
    var feces = document.getElementById("feces");
    var myChart = echarts.init(feces);
    var option = {
      tooltip: {
        trigger: "axis",
      },
      grid: {
        left: "5%",
        right: "5%",
        bottom: "5%",
        top: "15%",
        containLabel: true,
      },
      calculable: true,
      xAxis: [
        {
          boundaryGap: false,
          type: "category",
          data: ["1月", "2月", "3月", "4月", "5月", "6月"],
          axisLabel: {
            color: "white",
            interval: 0,
          },
          axisTick: {
            show: true,
          },
          splitLine: {
            show: false,
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "white",
            },
          },
        },
      ],
      yAxis: [
        {
          // name:'元',
          type: "value",
          axisLabel: {
            color: "white",
            formatter: "{value}元",
          },
          nameTextStyle: {
            color: "white",
          },
          splitLine: {
            show: true,
            lineStyle: {
              // 在 lineStyle 中设置线的样式
              color: "#02437c", // 将线的颜色设置为灰色
              opacity: 0.5,
            },
          },
        },
      ],
      series: [
        {
          name: "收益",
          type: "line",
          smooth: true,
          data: ["4200", "5600", "5000", "4851", "4984", "5626"],
          areaStyle: {},
           tooltip: {
            valueFormatter: function (value) {
              return value + "元";
            },
          },
          lineStyle: {
            // 设置线条的style等
            normal: {
              color: "#f3d321",
            },
          },
          itemStyle: {
            // 设置线条上点的颜色（和图例的颜色）
            normal: {
              color: "#f3d321",
            },
          },
          symbolSize: 8,
          itemStyle: {
            normal: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "#f9c01c", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#f9c01c11", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
          },
        },
      ],
    };
    myChart.setOption(option);
    // 监听窗口大小变化
    window.addEventListener("resize", () => {
      myChart.resize();
    });
  },
  created() {},
  methods: {},
};
</script>
<style lang="scss" scoped></style>
